<template>
  <v-card>
    <v-card-text class="pa-5">
      <v-form
        ref="formRef"
        class="multi-col-validation"
        @submit.prevent="handleSubmit"
      >
        <v-row>
          <v-col
            md="5"
            cols="12"
          >
            <v-text-field
              v-model="template.nome"
              dense
              outlined
              label="Nome do template"
              validate-on-blur
              hint="Máximo de 50 caracteres"
              :rules="[validators.required, v => (!!v && v.length <= 50) || 'Máximo de 50 caracteres']"
            />
          </v-col>

          <v-col
            md="4"
            cols="12"
          >
            <v-select
              v-model="template.tipoId"
              dense
              outlined
              label="Tipo do template"
              item-text="nome"
              item-value="id"
              validate-on-blur
              :items="tiposDeTemplates"
              :rules="[validators.select]"
            />
          </v-col>

          <v-col
            cols="3"
            class="pt-0"
          >
            <v-switch
              v-model="template.ativo"
              hide-details
              :label="`Status: ${template.ativo ? 'Ativo' : 'Inativo'}`"
            />
          </v-col>
        </v-row>

        <v-row class="d-flex align-center">
          <v-col
            md="5"
            cols="12"
          >
            <v-file-input
              ref="templateInputRef"
              dense
              outlined
              show-size
              hide-details
              validate-on-blur
              label="Importar template"
              accept=".txt"
              clear-icon
              :prepend-icon="null"
              :prepend-inner-icon="icons.mdiPaperclip"
              :rules="fileInputRules"
              @change="uploadTemplate"
            />
          </v-col>

          <v-col cols="auto">
            <v-btn
              color="primary"
              outlined
              @click="$refs.templateExemploRef.click()"
            >
              <v-icon left>
                {{ icons.mdiDownloadCircle }}
              </v-icon>

              <span>Download template de exemplo</span>

              <a
                ref="templateExemploRef"
                download
                target="_blank"
                :href="templateExemploUrl"
              ></a>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="6"
            class="d-flex justify-end"
          >
            <v-btn
              color="primary"
              type="submit"
            >
              <v-progress-circular
                v-if="loading"
                indeterminate
                class="mx-2"
              />

              <span v-else>{{ tituloBotaoSubmit }}</span>
            </v-btn>
          </v-col>

          <v-col cols="6">
            <v-btn
              outlined
              color="secondary"
              @click="resetData"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              hide-default-footer
              class="elevation-4"
              no-data-text="Nenhum template cadastrado"
              :item-class="() => 'cursor-pointer'"
              :headers="headers"
              :items="templatesCadastrados"
              @click:row="selecionarTemplate"
            >
              <template #item.nome="{ item }">
                <v-chip
                  color="accent"
                  outlined
                  class="text-truncate"
                >
                  {{ item.nome }}
                </v-chip>
              </template>

              <template #item.tipoNome="{ item }">
                <v-chip
                  color="info"
                  outlined
                  class="text-truncate"
                >
                  {{ item.tipoNome }}
                </v-chip>
              </template>

              <template #item.zenviaTemplateId="{ item }">
                <v-chip
                  color="primary"
                  outlined
                  class="text-truncate"
                >
                  {{ item.zenviaTemplateId }}
                </v-chip>
              </template>

              <template #item.conteudo="{ item }">
                <v-btn
                  icon
                  color="primary"
                  class="ml-2"
                  @click="downloadTemplateSelecionado(item.conteudo)"
                >
                  <v-icon>
                    {{ icons.mdiDownloadCircle }}
                  </v-icon>
                </v-btn>

                <a
                  ref="templateSelecionadoRef"
                  :href="templateSelecionadoUrl"
                  download="Template.txt"
                />
              </template>

              <template #item.dataUltimaAlteracao="{ item }">
                <td class="d-flex justify-center ml-n3">
                  <v-chip
                    v-if="item.dataUltimaAlteracao"
                    color="warning"
                    outlined
                  >
                    {{ functions.converterDateStringEmLocaleDateString(item.dataUltimaAlteracao) }}
                  </v-chip>

                  <span v-else>-</span>
                </td>
              </template>

              <template #item.ativo="{ item }">
                <td class="d-flex justify-center">
                  <v-chip
                    :color="`${item.ativo ? 'success' : 'error'}`"
                    outlined
                    class="text-truncate"
                  >
                    {{ item.ativo ? 'Ativo' : 'Inativo' }}
                  </v-chip>
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { ref, onMounted, computed } from '@vue/composition-api'
import { required, select } from '@core/utils/validation'
import { mdiPaperclip, mdiDownloadCircle } from '@mdi/js'
import { converterDateStringEmLocaleDateString } from '@/utils/dateTime'
import CanalWhatsAppTemplateModel from '@/models/entities/canal/CanalWhatsAppTemplateModel'
import CanalService from '@/services/modules/CanalService'
import ChatBotService from '@/services/modules/ChatBotService'
import ChatBotConfigWhatsAppTemplateModel from '@/models/entities/chat-bot/ChatBotConfigWhatsAppTemplateModel'

export default {
  props: {
    chatBotId: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    const tiposDeTemplates = ref([])
    const templatesCadastrados = ref([])

    async function getTiposDeTemplates() {
      tiposDeTemplates.value = await CanalService.getTiposDeTemplatesWhatsApp()
    }
    async function getTemplatesCadastrados() {
      templatesCadastrados.value = await ChatBotService.getConfigWhatsAppTemplates(props.chatBotId)
    }
    async function getData() {
      getTiposDeTemplates()
      getTemplatesCadastrados()
    }
    onMounted(getData)

    const templateSelecionadoUrl = ref(null)
    const templateSelecionadoRef = ref(null)

    function downloadTemplateSelecionado(conteudo) {
      const blob = new Blob([conteudo], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      templateSelecionadoUrl.value = url
      setTimeout(() => {
        templateSelecionadoRef.value.click()
        URL.revokeObjectURL(url)
      }, 10)
    }

    const formRef = ref(null)
    const loading = ref(false)

    const templateInputRef = ref(null)
    const template = ref(new CanalWhatsAppTemplateModel())
    function selecionarTemplate(t) {
      templateInputRef.value.reset()
      template.value = JSON.parse(JSON.stringify(t))
      template.value.conteudo = null
    }

    const isNovoTemplate = computed(() => template.value.id === 0)
    const tituloBotaoSubmit = computed(() => (isNovoTemplate.value ? 'Adicionar' : 'Atualizar'))
    const fileInputRules = computed(() => (isNovoTemplate.value ? [v => !!v || 'Template é obrigatório'] : []))

    function uploadTemplate(file) {
      if (!file) return
      const reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      reader.onload = () => {
        const content = reader.result
        template.value.conteudo = content
      }
    }

    function resetData() {
      templateInputRef.value.reset()
      template.value = new ChatBotConfigWhatsAppTemplateModel()
    }

    async function createTemplate() {
      try {
        loading.value = true
        await ChatBotService.criarTemplate(props.chatBotId, template.value)
        resetData()
        await getData()
      } finally {
        loading.value = false
      }
    }
    async function updateTemplate() {
      try {
        loading.value = true
        await ChatBotService.atualizarTemplate(props.chatBotId, template.value.id, template.value)
        resetData()
        await getData()
      } finally {
        loading.value = false
      }
    }
    async function handleSubmit() {
      if (loading.value) return
      if (formRef.value.validate() && isNovoTemplate.value) {
        createTemplate()
      } else if (formRef.value.validate() && !isNovoTemplate.value) {
        updateTemplate()
      } else {
        Vue.$toast.warning('Preencha corretamente os campos antes de salvar')
      }
    }

    const headers = [
      { text: 'Nome', value: 'nome' },
      { text: 'Tipo', value: 'tipoNome' },
      { text: 'Zenvia ID', value: 'zenviaTemplateId' },
      { text: 'Template', value: 'conteudo' },
      { text: 'Data alteração', value: 'dataUltimaAlteracao', align: 'center' },
      { text: 'Status', value: 'ativo', align: 'center' },
    ]
    const templateExemploUrl = 'https://vikdocumentdb.blob.core.windows.net/utils/TemplateResposta24Whatapp.txt?sv=2021-10-04&st=2023-04-25T18%3A07%3A38Z&se=2033-04-26T18%3A07%3A00Z&sr=b&sp=r&sig=%2FUK4TMtnHVJWgBnnXztHVtrxbopOmWFJ6oAmEiIzeh0%3D'

    return {
      tiposDeTemplates,
      templatesCadastrados,
      template,
      tituloBotaoSubmit,
      fileInputRules,
      uploadTemplate,
      selecionarTemplate,
      formRef,
      loading,
      templateSelecionadoRef,
      templateSelecionadoUrl,
      downloadTemplateSelecionado,
      templateInputRef,
      resetData,
      handleSubmit,
      validators: {
        required,
        select,
      },
      icons: {
        mdiPaperclip,
        mdiDownloadCircle,
      },
      functions: {
        converterDateStringEmLocaleDateString,
      },
      headers,
      templateExemploUrl,
    }
  },
}
</script>
